(function initWallCanvasRenderer() {
  const imageUrlPrefix = 'https://res.cloudinary.com/da9yd4bgx/image/fetch/t_canvas-mockup-v1/f_jpg,q_70/';

  function renderCanvasImage({ petName, imageUrl } = {}) {
    const mediaGallery = document.querySelector('.main-product__media-gallery');
    const titleElement = document.querySelector('.main-product__blocks h1');
    const imageElement =
      document.querySelector('.rte.caption img') ||
      document.querySelector('.main-product__media-gallery img') ||
      document.createElement('img');

    if (!mediaGallery || !imageUrl) {
      return;
    }

    if (petName && titleElement) {
      titleElement.innerHTML = `11 x 17 Canvas<br> ft. ${petName}`;
    }

    const canvasImageUrl = `${imageUrlPrefix}${encodeURIComponent(imageUrl)}`;
    imageElement.src = canvasImageUrl;
    imageElement.setAttribute('srcset', canvasImageUrl);

    mediaGallery.innerHTML = '';
    mediaGallery.append(imageElement);
  }

  function renderWallCanvasOffer({ dogId } = {}) {
    const mediaGallery = document.querySelector('.main-product__media-gallery');
    const titleElement = document.querySelector('.main-product__blocks h1');
    const imageElement =
      document.querySelector('.rte.caption img') ||
      document.querySelector('.main-product__media-gallery img') ||
      document.createElement('img');

    if (!mediaGallery) {
      return () => { };
    }

    mediaGallery.style.textAlign = 'center';
    mediaGallery.innerHTML = '<div class="loader"></div>';

    const renderSubmission = (submission) => {
      const submissionData = (submission && submission.data) || {};
      const submissionImageUrl = submissionData.image_url;
      const petName = submissionData.pet_name;

      if (petName && titleElement) {
        titleElement.innerHTML = `11 x 17 Canvas<br> ft. ${petName}`;
      }

      renderCanvasImage({ petName, imageUrl: submissionImageUrl });
    };

    return loadSubmissionWithCache({ dogId, onLoaded: renderSubmission });
  }

  function renderChristmasWallCanvasOffer({ petName, canvasImageUrl } = {}) {
    const mediaGallery = document.querySelector('.main-product__media-gallery');

    if (!mediaGallery || !canvasImageUrl) {
      return () => { };
    }

    mediaGallery.style.textAlign = 'center';
    mediaGallery.innerHTML = '<div class="loader"></div>';

    renderCanvasImage({ petName, imageUrl: canvasImageUrl });

    return () => { };
  }

  function renderTexturedPaintingCanvasOffer({ petName, offer, submissionOfferAssembly } = {}) {
    const mediaGallery = document.querySelector('.main-product__media-gallery');
    const resizedUrls = offer && offer.resize_image_urls;
    const resizedImageUrl =
      resizedUrls &&
      (resizedUrls['600'] || resizedUrls['480'] || resizedUrls['720'] || Object.values(resizedUrls)[0]);

    const submissionOfferImageUrl = submissionOfferAssembly && submissionOfferAssembly.image_files_used_cropped && submissionOfferAssembly.image_files_used_cropped[0];
    const useUrl = resizedImageUrl || submissionOfferImageUrl;

    if (!mediaGallery || !useUrl) {
      return () => { };
    }

    mediaGallery.style.textAlign = 'center';
    mediaGallery.innerHTML = '<div class="loader"></div>';

    renderCanvasImage({ petName, imageUrl: useUrl });

    return () => { };
  }

  window.renderWallCanvasOffer = renderWallCanvasOffer;
  window.renderChristmasWallCanvasOffer = renderChristmasWallCanvasOffer;
  window.renderTexturedPaintingCanvasOffer = renderTexturedPaintingCanvasOffer;
})();
